module.exports = __webpack_public_path__ + "img/uk-gc-1.b232bfbd.png";